<template>
	<div>
		<new-page-gen :options="options" />
	</div>
</template>

<script>
import NewPageGen from './NewPageGen.vue'

const config = {
	options: {
		resource: 'pickup-points',
		schemaModifier: async data => {
			data.autocompleteFields = [
				{
					name: 'clientId',
					resource: 'clients',
					query: 'id',
					display: 'id'
				}
			]
			return data
		}
	}
}

export default {
	name: 'PickupPointNew',
	components: { NewPageGen },
	data: () => config
}
</script>
